export default __webpack_public_path__ + "static/media/download_button_android.9d61f3f8.png";